import { createContext, useRef } from "react";

export const ScrollContext = createContext({
  aboutSection: null,
  navButton: null,
  portfolioSection: null,
});

const ScrollerProvider = ({ children }) => {
  const aboutSection = useRef(null);
  const navButton = useRef(null);
  const portfolioSection = useRef(null);
  const value = {
    aboutSection,
    navButton,
    portfolioSection,
  };
  return (
    <ScrollContext.Provider value={value}>{children}</ScrollContext.Provider>
  );
};

export default ScrollerProvider;
